"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = void 0;
const login_form_1 = require("./login-form");
require("./login-page.scss");
class LoginPage {
    constructor(id) {
        this.page = document.createElement('div');
        this.page.id = id;
        this.loginForm = new login_form_1.LoginForm('login-form');
    }
    static createTitle(title, hElement) {
        const headerTitle = hElement === 'main' ? document.createElement('h1') : document.createElement('h3');
        headerTitle.innerText = title;
        return headerTitle;
    }
    render() {
        const title = LoginPage.createTitle(LoginPage.loginPageText.title, 'main');
        const subtitle = LoginPage.createTitle(LoginPage.loginPageText.subtitle, 'sub');
        const container = document.createElement('div');
        container.classList.add('loginpage-container');
        const loginForm = this.loginForm.render();
        const content = document.createElement('div');
        content.className = 'login-element';
        content.append(title);
        content.append(subtitle);
        content.append(loginForm);
        container.append(content);
        this.page.append(container);
        return this.page;
    }
}
exports.LoginPage = LoginPage;
LoginPage.loginPageText = {
    title: 'RSS Puzzle Game',
    subtitle: 'enter your name for start'
};
